import { useAuth } from "../context/AuthContext";
import MdDashboard from "./dashboards/MdDashboard";
import VpDashboard from "./dashboards/VpDashboard";
import ZonalDashboard from "./dashboards/ZonalDashboard";
import BranchDashboard from "./dashboards/BranchDashboard";
import HrOpsDashboard from "./dashboards/HrOpsDashboard";

const VIEW_BY_ROLE = {
  AMD: MdDashboard,
  SYSTEM_ADMIN: MdDashboard,
  HR_HEAD: MdDashboard,
  AUDITOR: MdDashboard,
  VERTICAL_HEAD_VP: VpDashboard,
  FUNCTIONAL_HEAD: VpDashboard,
  ZONAL_HEAD: ZonalDashboard,
  BRANCH_HEAD: BranchDashboard,
  BRANCH_DEPT_HEAD: BranchDashboard,
  HR_OPERATIONS: HrOpsDashboard,
  HR_RECRUITER: HrOpsDashboard,
};

export default function Dashboard() {
  const { user } = useAuth();
  const View = VIEW_BY_ROLE[user?.role] || MdDashboard;
  return <View />;
}
